export const filter = {
	filterVue: {
		instance: '.filterVue',
	},
}
